module.exports = __webpack_public_path__ + "img/TXFFC30S.png";